import {Injectable} from "@angular/core";

import {ApiService} from "app/services/domain/api.service";
import * as SharedSvc from "app/services/domain/base.service";
import {TagBaselineDefinitionsService} from "app/services/domain/tag-baseline-definitions.service";
import * as Models from "app/services/proxy/model/models";

import {CacheService} from "framework/services/cache.service";
import {ErrorService} from "framework/services/error.service";

@Injectable()
export class TagBaselineDefinitionVersionsService extends SharedSvc.BaseDefinitionVersionService<Models.TagBaselineConfiguration, Models.TagBaselineDefinitionVersion, Models.TagBaselineDefinition, TagBaselineDefinitionVersionExtended>
{
    constructor(api: ApiService,
                errors: ErrorService,
                cache: CacheService)
    {
        super(api, errors, cache, Models.TagBaselineDefinitionVersion, TagBaselineDefinitionVersionExtended.newInstance);
    }

    //--//

    async makeHead(id: string): Promise<TagBaselineDefinitionVersionExtended>
    {
        let model = await this.api.tagBaselineDefinitionVersionsApi.makeHead(id);
        return this.wrapModel(model);
    }

    async makeRelease(id: string): Promise<TagBaselineDefinitionVersionExtended>
    {
        let model = await this.api.tagBaselineDefinitionVersionsApi.makeRelease(id);
        return this.wrapModel(model);
    }

    createVersion(model: Models.TagBaselineDefinitionVersion): Promise<Models.TagBaselineDefinitionVersion>
    {
        return this.api.tagBaselineDefinitionVersionsApi.create(model);
    }

    //--//

    protected cachePrefix(): string { return "TagBaselineDefinitionVersion"; }

    protected getRaw(id: string): Promise<Models.TagBaselineDefinitionVersion>
    {
        return this.api.tagBaselineDefinitionVersionsApi.get(id);
    }

    protected getBatchRaw(ids: string[]): Promise<Models.TagBaselineDefinitionVersion[]>
    {
        const request = Models.RecordIdentityBatchRequest.newInstance({ids: ids.map(id => TagBaselineDefinitionVersionExtended.newIdentity(id))});
        return this.api.tagBaselineDefinitionVersionsApi.batch(request);
    }

    protected canBatch(): boolean
    {
        return true;
    }
}

export class TagBaselineDefinitionVersionExtended extends SharedSvc.ExtendedDefinitionVersionModel<Models.TagBaselineConfiguration, Models.TagBaselineDefinitionVersion, Models.TagBaselineDefinition>
{
    static newInstance(svc: TagBaselineDefinitionVersionsService,
                       model: Models.TagBaselineDefinitionVersion): TagBaselineDefinitionVersionExtended
    {
        return new TagBaselineDefinitionVersionExtended(svc, model, "TagBaselineDefinitionVersion");
    }

    public static newIdentity(sysId?: string): Models.RecordIdentity
    {
        return Models.RecordIdentity.newInstance({
                                                     table: "TagBaselineDefinitionVersion",
                                                     sysId: sysId
                                                 });
    }

    //--//

    protected definitionSvc(): TagBaselineDefinitionsService
    {
        return this.domain.tagBaselineDefinitions;
    }

    protected definitionVersionSvc(): TagBaselineDefinitionVersionsService
    {
        return this.domain.tagBaselineDefinitionVersions;
    }
}

export function extractDefinedTags(key: string): string
{
    return key.startsWith("defined_tags.")
        ? key.substring("defined_tags.".length)
        : key;
}

export function isOciDefinedTag(key: string): boolean
{
    return key.startsWith("defined_tags.");
}